import React from 'react';
import { indirizzoNelBrowser } from '../../services/telegramAccesso';
import i18next from 'i18next';

/**
 * «APRI NEL BROWSER». Si vede quando il pulsante del bot ha aperto il sito
 * dentro Telegram: il biglietto non e' ancora stato usato, quindi passa intatto
 * a Safari o Chrome, dove la registrazione (o l'accesso) resta valida anche
 * dopo. «Continua qui» usa il biglietto in Telegram, come prima.
 *
 * Telegram non lascia scegliere al bot dove aprire i link: se il tasto non
 * apre il browser, resta la via del menu ⋯ › «Apri in Safari / Chrome».
 */
export default function ApriNelBrowser() {
  const qui = window.location.href;
  const fuori = indirizzoNelBrowser(qui);
  const continuaQui = () => {
    const u = new URL(qui);
    u.searchParams.set('qui', '1');
    window.location.replace(u.toString());
  };
  const iPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent || '');
  const pulsante = {
    display: 'block', width: '100%', boxSizing: 'border-box', height: 52, lineHeight: '52px',
    border: 0, borderRadius: 'var(--lvc-radius-0, 4px)', textAlign: 'center', textDecoration: 'none',
    fontFamily: 'inherit', fontSize: 15, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', cursor: 'pointer',
  };
  return (
    <div role="dialog" aria-modal="true" aria-labelledby="titolo-browser"
         style={{ position: 'fixed', inset: 0, zIndex: 300, background: 'var(--lvc-surface-1, #111)', color: 'var(--lvc-text-1, #fff)',
           display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <h3 id="titolo-browser" style={{ margin: '0 0 8px', fontSize: 20 }}>{i18next.t('Continua nel browser')}</h3>
        <p style={{ margin: '0 0 20px', color: 'var(--lvc-text-2, #ccc)', fontSize: 14, lineHeight: 1.5 }}>
          {i18next.t('Sei dentro Telegram. Apri il sito in')}{' '}{iPhone ? i18next.t('Safari') : i18next.t('Chrome')}{i18next.t(': così resti collegato anche dopo, quando torni sul sito.')}
        </p>
        {fuori ? (
          <a href={fuori} style={{ ...pulsante, background: 'var(--lvc-accent-deep, #6d28d9)', color: '#fff' }}>
            {i18next.t('Apri in')}{' '}{iPhone ? i18next.t('Safari') : i18next.t('Chrome')}
          </a>
        ) : null}
        <button type="button" onClick={continuaQui}
                style={{ ...pulsante, marginTop: 10, background: 'transparent', color: 'var(--lvc-text-1, #fff)', border: '1px solid var(--lvc-line, #444)' }}>
          {i18next.t('Continua qui')}
        </button>
        <p style={{ margin: '16px 0 0', color: 'var(--lvc-text-3, #999)', fontSize: 12, lineHeight: 1.5 }}>
          {i18next.t('Se non si apre: tocca ⋯ in alto a destra e scegli «Apri in')}{' '}{iPhone ? i18next.t('Safari') : i18next.t('Chrome')}».
        </p>
      </div>
    </div>
  );
}
